import React from 'react'

const Dots = (props) => (
    <svg width="3" height="13" viewBox="0 0 3 13" fill={props.color ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props.opacity ? props.opacity : '0.5'}>
            <circle r="1.5" transform="matrix(-4.37114e-08 1 1 4.37114e-08 1.50024 1.5)" />
            <circle r="1.5" transform="matrix(-4.37114e-08 1 1 4.37114e-08 1.5 6.5)" />
            <circle r="1.5" transform="matrix(-4.37114e-08 1 1 4.37114e-08 1.5 11.5)" />
        </g>
    </svg>
)

export default Dots
